// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__7mZV0"};